import { render, staticRenderFns } from "./appointment-info.vue?vue&type=template&id=606d563d&scoped=true"
import script from "./appointment-info.vue?vue&type=script&lang=js"
export * from "./appointment-info.vue?vue&type=script&lang=js"
import style0 from "./appointment-info.vue?vue&type=style&index=0&id=606d563d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606d563d",
  null
  
)

export default component.exports